<template>
    <div class="inner">
      <ScrollupSection />
      <div class="all-area">
        <HeaderSection v-if="!isEmbed" />
        <PrivacyPolicySection />
        <FooterSection v-if="!isEmbed" />
      </div>
    </div>
  </template>
  
  <script>
  import ScrollupSection from '../../Scrollup/Scrollup'
  import HeaderSection from '../../Header/HeaderOne'
  import PrivacyPolicySection from '../../PrivacyPolicy/PrivacyPolicy'
  import FooterSection from '../../Footer/Footer'
  
  export default {
    name: 'Contact',
    components: {
      ScrollupSection,
      HeaderSection,
      PrivacyPolicySection,
      FooterSection
    },
    data() {
      return {
        isEmbed: false
      };
    },
    mounted() {
      const embed = this.$route.query.embed;
      this.isEmbed = !!embed;
    }
  }
  </script>
  
  <style>
  
  </style>